module.exports = __webpack_public_path__ + "static/media/rome-15.0461ce88.jpg";